import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";

//Import Charts
import ReactApexChart from "react-apexcharts";
import "./dashboard.scss";
import { salesAnalytics } from "../Utility/dataSet";
import {  lkBrandBlue, lkGreen, lkLightBg, lkOrange } from "../Utility/styleComponents";
import { connect } from "react-redux";

const SalesAnalytics = (props) => {
  const { dateRange, location,layoutType } = props?.dbFilter;
  const [salesSeries, setSalesSeries] = useState([]);
  const donutOptions = {
    labels: ["Four-wheeler", "Three-wheeler", "Two-wheeler"],
    plotOptions: {
      donut: {
        donut: {
          size: "66.66%",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    colors: [lkBrandBlue, lkGreen, lkOrange],
  };
  const pieOptions = {
    labels: ["Four-wheeler", "Three-wheeler", "Two-wheeler"],
    plotOptions: {
      pie: {
        pie: {
          size: "45%",
        },
      },
    },
    customScale: 0.9,
    dataLabels: {
      enabled: true,
      style: {
        color: [lkLightBg],
      },
    },

    legend: {
      show: false,
    },
    // colors: ["#88B6FB", "#85CCA2", "#F7C891"],
    colors: ["rgba(136, 182, 251, 0.6)", "rgba(133, 204, 162, 0.6)", "rgba(247, 200, 145, 0.6)"],
  };

  useEffect(() => {
    filterSeriesOnDate();
  }, [dateRange]);
  const filterSeriesOnDate = () => {
    const currentDateRange = dateRange;
    const startDate = new Date(currentDateRange[0]);
    const endDate = new Date(currentDateRange[1]);
    const filteredData = salesAnalytics(startDate, endDate);
    setSalesSeries(filteredData);
  };
// console.log("salesSeries:",salesSeries);

  return (
    <React.Fragment>
      <Card style={{ height: "470px" }}>
        <CardBody>
          <h4 className="card-title mb-4">Utilization Analytics</h4>

          <div id="donut-chart" className="apex-charts">
            <div className="d-flex justify-content-center">
              {/* Donut Chart */}
              {salesSeries && salesSeries?.length > 0 && (
                <>
                  <div
                    style={{
                      position: "relative",
                      width: "360px",
                      height: "360px",
                    }}
                  >
                    <ReactApexChart options={donutOptions} series={salesSeries} type="donut" height={`${layoutType ==="vertical" ? "330":"310"}`} />
                  </div>
                  {/* pie chart */}
                  <div
                    style={{
                      position: "absolute",
                      top: "24.4%",
                      left: "10.10%",
                      width: "80%",
                      height: "80%",
                    }}
                  >
                    <ReactApexChart options={pieOptions} series={salesSeries} type="pie" height={`${layoutType ==="vertical" ? "225":"206"}`}/>
                  </div>
                </>
              )}
            </div>
          </div>

          <Row>
            <Col xs={4}>
              <div className="text-center ">
                <p className="mb-2 text-truncate">
                  <i className="mdi mdi-circle text-primary font-size-10 mr-1"></i> Four-wheeler
                </p>
                {/* <h5>45 %</h5> */}
              </div>
            </Col>
            <Col xs={4}>
              <div className="text-center ">
                <p className="mb-2 text-truncate">
                  <i className="mdi mdi-circle text-success font-size-10 mr-1"></i> Three-wheeler
                </p>
                {/* <h5>35 %</h5> */}
              </div>
            </Col>
            <Col xs={4}>
              <div className="text-center">
                <p className="mb-2 text-truncate">
                  <i className="mdi mdi-circle text-warning font-size-10 mr-1"></i> Two-wheeler
                </p>
                {/* <h5>20 %</h5> */}
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(SalesAnalytics);
